import { apiRequest } from 'platform/utilities/api';
import environment from '~/platform/utilities/environment';

let organizationsCache = null;
let organizationsCachePromise = null;
let fetchFailed = false;

const normalizeOrganizations = response => {
  const list = response?.data || [];

  return list
    .map(item => {
      const attributes = item?.attributes || {};

      const name = attributes.name || '';
      const city = attributes.city || '';
      const state = attributes.state || '';

      return {
        id: item?.id || name,
        value: name,
        name,
        phone: attributes.phone || '',
        city,
        state,
        street: attributes.street || '',
        street2: attributes.street2 || '',
        postalCode: attributes.zipCode || attributes.postalCode || '',
        label: [name, city, state].filter(Boolean).join(', '),
      };
    })
    .filter(item => item.name);
};

export const getOrganizationOptions = async (inputValue = '') => {
  const query = inputValue.trim().toLowerCase();
  const filter = list => {
    if (!query) {
      return list;
    }

    return list.filter(organization => {
      const haystack = [
        organization.label,
        organization.name,
        organization.city,
        organization.state,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return haystack.includes(query);
    });
  };

  if (organizationsCache?.length) return filter(organizationsCache);

  if (organizationsCachePromise) {
    const list = await organizationsCachePromise;
    return filter(list);
  }

  organizationsCachePromise = apiRequest(
    `${environment.API_URL}/v0/form21p530a/cemeteries`,
  )
    .then(normalizeOrganizations)
    .then(organizations => {
      fetchFailed = false;
      return organizations;
    })
    .catch(() => {
      fetchFailed = true;
      return [];
    })
    .finally(() => {
      organizationsCachePromise = null;
    });

  const results = await organizationsCachePromise;

  // Only cache successful, non-empty results so a failed fetch can be retried
  if (results.length > 0) {
    organizationsCache = results;
  }

  return filter(results);
};

export const didFetchFail = () => fetchFailed;

export const isCacheReady = () =>
  organizationsCache !== null && organizationsCache.length > 0;

export const getCachedOrganizationByName = organizationName => {
  if (!organizationsCache || !organizationName) {
    return null;
  }

  const needle = organizationName.trim().toLowerCase();

  return (
    organizationsCache.find(
      organization =>
        (organization.value || '').trim().toLowerCase() === needle ||
        (organization.name || '').trim().toLowerCase() === needle ||
        (organization.label || '').trim().toLowerCase() === needle,
    ) || null
  );
};

export const setOrganizationsCacheForTesting = organizations => {
  if (organizations === null) {
    organizationsCache = null;
  } else {
    organizationsCache = Array.isArray(organizations) ? organizations : [];
  }
  organizationsCachePromise = null;
  fetchFailed = false;
};